import datePickIcon from "../images/5.png";
import pacmanIcon from "../images/9.png";
import userIcon from "../images/10.png";
import backIcon from "../images/Back.png";
import enlargeIcon from "../images/povecaj.png";
import sortingIcon from "../images/Sort.png";
import downloadPdfIcon from "../images/Download.png";
import searchIcon from "../images/Search.png";
import documentIcon from "../images/dokument.png";
import imgIcon from "../images/8.png";
import wwwIcon from "../images/7.png";
import msgIcon from "../images/1.png";
import Button from "../Button/Button";
import FilterFolder from "../FilterFolder";
import axios from "axios";
import { compareAsc, format } from "date-fns";
import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../Context/Context";
import EditorCalendar from "../../../../Editor/EditorCalendar/EditorCalendar";
import CategoryFilter from "../../../../Editor/Archive/FilterArchive/CategoryFilter";
import UserFilter from "../../../../Editor/Archive/FilterArchive/UserFilter";

const FilterPortrait = ({
  handleReturn,
  setDetailedChecked,
  allData,
  daysArchive,
  setShowingItems,
  location,
  showingItems,
  filterState,
  setFilterState,
  setPdfItems,
  location_input,
  aspectRatio,
}) => {
  const { baseUrl } = useGlobalContext();
  const { apiKey, loggedUser } = useGlobalContext();
  const [sortingChecked, setSortingChecked] = useState(false);
  const [calendarActive, setCalendarActive] = useState({
    value: false,
    dateToSet: 0,
  });
  const [openUser, setOpenUser] = useState(false);
  const [openChart, setOpenChart] = useState(false);
  const [countMessage, setCountMessage] = useState({
    messages: 0,
    documents: 0,
    links: 0,
    images: 0,
  });

  const handlePreviewPdf = () => {
    const items = showingItems.map((itemSelect) => {
      return handleGetItems(itemSelect);
    });

    Promise.all(items).then((newValues) => {
      console.log(newValues);
      let newShowingItems = [];
      newValues.forEach(async (values, index) => {
        console.log(showingItems[index]);
        const value = await Promise.all(values);
        const newItem = {
          ...showingItems[index],
          id: showingItems[index].id,
          dataItems: value[2].data.data,
          images:
            value[0].data.images !== undefined ? value[0].data.images : [],
          links: !showingItems[index].linkActive
            ? showingItems[index]?.links
            : [],
          documents:
            value[1].data.documents === undefined ||
            showingItems[index].documentActive
              ? []
              : value[1].data.documents,
          categories: value[3]?.data?.categories,
        };
        newShowingItems.push(newItem);
        if (newShowingItems.length === showingItems.length) {
          handleAddComment().then((items) => {
            const newItems = items.map((item, index) => {
              return {
                ...item,
                images: newShowingItems[index].images,
                documents: newShowingItems[index].documents,
                categories: newShowingItems[index].categories,
                dataItems: newShowingItems[index].dataItems,
              };
            });
            console.log(newItems);
            setPdfItems(newItems);
            setDetailedChecked(true);
          });
        }
      });
    });
  };

  const handleChangeColorButton = (index) => {
    const realIndex = index + 2; // prvi parametar krece od indeksa 2
    const filters = Object.values(filterState);
    const filtersName = Object.keys(filterState)[realIndex];
    const newValue =
      filters[realIndex].value === 2 ? 0 : filters[realIndex].value + 1;
    const newData = { count: filters[realIndex].count, value: newValue };
    setFilterState({ ...filterState, [filtersName]: newData });
  };

  const setColor = (value) => {
    switch (value) {
      case 0:
        return "gray";
      case 1:
        return "red";
      case 2:
        return "green";
    }
  };

  const handleGetItems = (itemChange) => {
    console.log(itemChange);
    let promises = [];
    const responseImages = axios.post(
      `${baseUrl}/items/getAllImagesByItemId.php`,
      {
        item_id: itemChange.id,
        api_key: apiKey,
        user_id: loggedUser.id,
      }
    );
    promises.push(responseImages);
    const responseDocument = axios.post(
      `${baseUrl}/items/getAllDocumentsByItemId.php`,
      {
        item_id: itemChange.id,
        api_key: apiKey,
        user_id: loggedUser.id,
      }
    );
    promises.push(responseDocument);
    const responseFields = axios.post(
      `${baseUrl}/items/getAllFieldsByItemId.php`,
      {
        item_id: itemChange.id,
        api_key: apiKey,
        user_id: loggedUser.id,
      }
    );
    promises.push(responseFields);
    const responseCategory = axios.post(
      `${baseUrl}/categories/getAllCategoriesByLocationId.php`,
      {
        location_input,
        location_id: parseInt(location.location_id),
        api_key: apiKey,
        user_id: loggedUser.id,
        item_id: itemChange.id,
      }
    );

    promises.push(responseCategory);

    // ovde treba za komentare

    return promises;
    //razresenje promisa
    /* Promise.all(promises).then((values) => {
      console.log(values);
      const newItem = {
        id: itemChange.id,
        dataItems: values[2].data.data,
        images:
          values[0].data.images !== undefined ? values[0].data.images : [],
        link: itemChange?.links,
        documents:
          values[1].data.documents === undefined
            ? []
            : values[1].data?.documents[0],
        categories: values[3]?.data?.categories,
      };
      console.log(newItem);
      return newItem;
    });*/
  };

  const handleAddComment = async () => {
    const responseImages = [];
    const responseDocuments = [];
    showingItems.forEach((item) => {
      item.comments.forEach((comment) => {
        try {
          const imageResponse = axios.post(
            `${baseUrl}/items/getAllImagesByCommentId.php`,
            {
              item_id: item.id,
              api_key: apiKey,
              user_id: loggedUser.id,
              comment_id: comment.id,
            }
          );
          responseImages.push({
            promise: imageResponse,
            commentId: comment.id,
          });
        } catch (error) {
          console.log("Error fetching comment images");
        }

        try {
          const documentResponse = axios.post(
            `${baseUrl}/items/getAllDocumentsByCommentId.php`,
            {
              item_id: item.id,
              api_key: apiKey,
              user_id: loggedUser.id,
              comment_id: comment.id,
            }
          );
          responseDocuments.push({
            promise: documentResponse,
            commentId: comment.id,
          });
        } catch (error) {
          console.log("Error fetching comment documents");
        }
      });
    });

    const newImages = await Promise.all(responseImages.map((r) => r.promise));
    const images = newImages.map((newImage, i) => {
      if (newImage.data.images !== "") {
        const image = newImage.data.images[0];
        return {
          data: image.data === null ? "" : image.data,
          title: image.title === null ? "" : image.title,
          commentId: responseImages[i].commentId,
        };
      } else {
        return {
          data: "",
          title: "",
          commentId: responseImages[i].commentId,
        };
      }
    });
    console.log(images);
    const newDocuments = await Promise.all(
      responseDocuments.map((r) => r.promise)
    );
    console.log(newDocuments);
    const documents = newDocuments.map((docum, i) => {
      console.log(docum.data.documents);
      if (docum.data.status === 200) {
        const doc = docum.data.documents[0];
        console.log(doc);
        return {
          data: doc.length === 0 ? "" : doc.data,
          name: doc.length === 0 ? "" : doc.name,
          commentId: responseDocuments[i].commentId,
        };
      } else {
        return {
          data: "",
          name: "",
          commentId: responseDocuments[i].commentId,
        };
      }
    });
    console.log(documents);

    const newItemList = showingItems.map((item) => {
      const newComments = item.comments.map((comment) => {
        const commentImages = images.find(
          (img) => img.commentId === comment.id
        );
        const commentDocuments = documents.find(
          (doc) => doc.commentId === comment.id
        );
        console.log(comment);
        console.log(images);
        console.log(commentDocuments);
        console.log(item);
        return {
          ...comment,
          image: commentImages.data !== "" ? commentImages : [],
          document:
            commentDocuments.data !== "" ? [commentDocuments] || [] : [],
        };
      });
      if (!item.commentActive) return { ...item, comments: newComments };
      else {
        return { ...item, comments: [] };
      }
    });
    console.log(newItemList);

    const newShowingItems = showingItems.map((newItem, index) => {
      return {
        ...showingItems[index],
        comments: newItemList[index].comments,
      };
    });
    return newShowingItems;
  };

  const handleSort = () => {
    let newItemList = [];
    if (!sortingChecked)
      // pretpostavimo da kada su se dodavale nove stavke
      // da je inicijalno sortirano u rastucem redosledu
      newItemList = showingItems.sort((a, b) => {
        return compareAsc(a.timeCreated, b.timeCreated);
      });
    else
      newItemList = showingItems.sort((a, b) => {
        return compareAsc(b.timeCreated, a.timeCreated);
      });
    setShowingItems(newItemList);
    setSortingChecked(!sortingChecked);
  };

  const handleSearch = () => {
    //setFilterModalActive(false);
    let filteredData = allData;
    let greenExists;
    let redExists;

    // filtriranje po datumu
    if (filterState.endDate === "") {
      const newFilteredData = [];
      filteredData.forEach((fd) => {
        console.log("prvi", fd);
        if (
          compareAsc(
            new Date(new Date(fd.timeCreated).setHours(0, 0, 0, 0)),
            filterState.startDate
          ) === 0
        )
          newFilteredData.push(fd);
      });
      filteredData = newFilteredData;
    } else {
      const newFilteredData = [];
      filteredData.forEach((fd) => {
        console.log("prvi", fd);
        console.log(
          new Date(new Date(filterState.startDate).setHours(0, 0, 0, 0))
        );
        console.log(
          new Date(new Date(filterState.endDate).setHours(0, 0, 0, 0))
        );
        if (
          compareAsc(
            new Date(new Date(fd.timeCreated).setHours(0, 0, 0, 0)),
            new Date(new Date(filterState.startDate).setHours(0, 0, 0, 0))
          ) >= 0 &&
          compareAsc(
            new Date(new Date(fd.timeCreated).setHours(0, 0, 0, 0)),
            new Date(new Date(filterState.endDate).setHours(0, 0, 0, 0))
          ) <= 0
        )
          newFilteredData.push(fd);
      });
      filteredData = newFilteredData;
    }

    const items = Object.values(filterState);
    const dataItems = [items[2], items[3], items[4], items[5]];
    /*const itemsKeys = Object.values(filterState);
    const dataKeys = [itemsKeys[2], itemsKeys[3], itemsKeys[4], itemsKeys[5]];*/
    greenExists = dataItems.find((dataItem) => dataItem.value === 2);
    redExists = dataItems.find((dataItem) => dataItem.value === 1);
    // 4 sa strane
    // ako postoji zeleno, gledam samo zelene
    if (greenExists) {
      if (filterState.message.value === 2)
        filteredData = filteredData.filter(
          (item) => item.comments.length !== 0
        );
      if (filterState.documents.value === 2)
        filteredData = filteredData.filter(
          (item) => item.documents.length !== 0
        );
      if (filterState.image.value === 2)
        filteredData = filteredData.filter((item) => item.images.length !== 0);
      if (filterState.link.value === 2)
        filteredData = filteredData.filter((item) => item.links.length !== 0);
    } else if (redExists) {
      if (filterState.message.value === 1)
        filteredData = filteredData.filter(
          (item) => item.comments.length === 0
        );
      if (filterState.documents.value === 1)
        filteredData = filteredData.filter(
          (item) => item.documents.length === 0
        );
      if (filterState.image.value === 1)
        filteredData = filteredData.filter((item) => item.images.length === 0);
      if (filterState.link.value === 1)
        filteredData = filteredData.filter((item) => item.links.length === 0);
    }
    // kategorije
    if (filterState.category.length !== 0) {
      const filterCategories = filterState.category.map((cat) => cat.id);
      const newFilteredData = [];
      filteredData.forEach((fd) => {
        if (
          filterCategories.length ===
          fd.categories.filter((cat) => filterCategories.includes(cat)).length
        )
          newFilteredData.push(fd);
      });

      filteredData = newFilteredData;
    }

    // useri
    if (filterState.people.length !== 0) {
      const userIds = filterState.people.map((p) => p.user_id);
      filteredData = filteredData.filter((fd) =>
        userIds.some((item) => item === fd.user_id)
      );
    }
    console.log(filteredData);
    console.log(allData);
    /*
    const newFilteredData = filteredData.map((item) => { 
      console.log(item)
      console.log(item.document)
      const documents = item.document
      delete item["document"]
      return {...item,documents:documents};
    })*/
    // console.log(newFilteredData)
    const sortedFilteredData = filteredData.sort((a, b) => {
      return compareAsc(a.timeCreated, b.timeCreated);
    });
    const modifiedData = sortedFilteredData.map((item) => {
      return {
        ...item,
        commentsActive: false,
        linkActive: false,
        documentActive: false,
        imgActive: false,
      };
    });
    console.log(modifiedData);

    let countMessages = 0;
    let countLinks = 0;
    let countDocuments = 0;
    let countImages = 0;
    modifiedData.forEach((item) => {
      countMessages += item.comments.length;
      countLinks += item.links.length;
      countDocuments += item.documents.length;
      countImages += item.images.length;
    });

    setCountMessage({
      messages: countMessages,
      links: countLinks,
      documents: countDocuments,
      images: countImages,
      items: modifiedData.length,
    });

    setShowingItems(modifiedData);
  };

  const setDimensions = () => {
    const folderAppDim = document
      .querySelector(".folder-app")
      .getBoundingClientRect();
    const header = document.querySelector(".filter-portrait-header");
    header.style.height = `${folderAppDim.height / 10}px`;
    const dateSelector = document.querySelector(
      ".filter-portrait-date-selector"
    );
    dateSelector.style.height = `${(folderAppDim.height / 100) * 15}px`;
    const main = document.querySelector(".filter-portrait-main");
    main.style.height = `${(folderAppDim.height / 100) * 55}px`;
    const items = document.querySelectorAll(".filter-folder.portait");
    items.forEach(
      (item) => (item.style.height = `${folderAppDim.height / 10}px`)
    );
  };

  window.addEventListener("resize", setDimensions);

  useEffect(() => {
    setDimensions();
    return () => window.removeEventListener("resize", setDimensions);
  }, []);

  return (
    <>
      <div className="filter-portrait-header">
        <div className="add-button" onClick={handleReturn}>
          <Button image={backIcon} />
        </div>
        <div className="add-button" onClick={handleSort}>
          <Button image={sortingIcon} />
        </div>
        <div className="add-button">
          <Button image={enlargeIcon} />
        </div>
        <div className="add-button" onClick={() => handlePreviewPdf()}>
          <Button image={downloadPdfIcon} />
        </div>
      </div>
      <div className="filter-portrait-date-selector">
        <div className="date-selector-portrait-buttons">
          <div
            className="date-selector-portrait-btn"
            onClick={() =>
              setCalendarActive({
                value: !calendarActive.value,
                dateToSet: 0,
              })
            }
          >
            <Button>
              <img
                src={datePickIcon}
                alt=""
                className="date-selector-portrait-img"
              />
            </Button>
          </div>
          <div
            className={`date-selector-portrait-btn ${
              filterState.startDate == "" && "blurred"
            }`}
            onClick={() =>
              setCalendarActive({
                value: !calendarActive.value,
                dateToSet: 1,
              })
            }
          >
            <Button>
              <img
                src={datePickIcon}
                alt=""
                className="date-selector-portrait-img"
              />
            </Button>
          </div>
        </div>
        <div className="date-selector-portrait-spans">
          <span>
            {" "}
            {filterState.startDate === ""
              ? ""
              : format(filterState.startDate, "dd.MM.yyyy")}
          </span>
          <span>
            {filterState.endDate === ""
              ? ""
              : format(filterState.endDate, "dd.MM.yyyy")}
          </span>
        </div>
      </div>
      <div className="filter-portrait-main">
        <div className="filter-portrait-main-left">
          <div
            className="filter-options-portrait-main-left-btn"
            onClick={() => handleChangeColorButton(0)}
          >
            <Button activation={true}>
              <div
                className={`button-div ${setColor(filterState.message.value)}`}
              >
                <img
                  src={msgIcon}
                  className="filter-options-portrain-btn-img"
                  alt=""
                />
              </div>
            </Button>
            <div className="circle">{countMessage.messages}</div>
          </div>
          <div
            className="filter-options-portrait-main-left-btn"
            onClick={() => handleChangeColorButton(1)}
          >
            <Button activation={true}>
              <div
                className={`button-div ${setColor(
                  filterState.documents.value
                )}`}
              >
                <img
                  src={documentIcon}
                  className="filter-options-portrain-btn-img"
                  alt=""
                />
              </div>
            </Button>
            <div className="circle">{countMessage.documents}</div>
          </div>
          <div
            className="filter-options-portrait-main-left-btn"
            onClick={() => handleChangeColorButton(2)}
          >
            <Button activation={true}>
              <div className={`button-div ${setColor(filterState.link.value)}`}>
                <img
                  src={wwwIcon}
                  className="filter-options-portrain-btn-img"
                  alt=""
                />
              </div>
            </Button>
            <div className="circle">{countMessage.links}</div>
          </div>
          <div
            className="filter-options-portrait-main-left-btn"
            onClick={() => handleChangeColorButton(3)}
          >
            <Button activation={true}>
              <div
                className={`button-div ${setColor(filterState.image.value)}`}
              >
                <img
                  src={imgIcon}
                  className="filter-options-portrain-btn-img"
                  alt=""
                />
              </div>
            </Button>
            <div className="circle">{countMessage.images}</div>
          </div>
        </div>
        <div className="filter-portrait-main-middle">
          <div
            className="filter-options-portrait-main-middle-btn"
            onClick={() => setOpenChart(!openChart)}
          >
            <Button image={pacmanIcon} />
          </div>
          <div
            className="filter-options-portrait-main-middle-btn"
            onClick={() => setOpenUser(!openUser)}
          >
            <Button image={userIcon} />
          </div>
        </div>
        <div className="filter-portrait-main-right" onClick={handleSearch}>
          <span>PRIKAZI</span>
          <div className="filter-options-portrait-main-btn">
            <Button activation={true}>
              <div className="filter-options-search-container">
                <img
                  src={searchIcon}
                  alt=""
                  className="filter-options-search-img"
                />
                <span className="filter-options-search-size">
                  {showingItems.length}
                </span>
              </div>
            </Button>
          </div>
        </div>
      </div>

      <>
        {showingItems.map((item, index) => {
          return (
            <FilterFolder
              file={item}
              index={index}
              showingItems={showingItems}
              setShowingItems={setShowingItems}
              sortingChecked={sortingChecked}
              aspectRatio={aspectRatio}
            />
          );
        })}
      </>

      {openChart && (
        <CategoryFilter
          filterState={filterState}
          setFilterState={setFilterState}
          setOpenChart={setOpenChart}
          isFromFilter={true}
          locationFolder={location}
        />
      )}
      {openUser && (
        <UserFilter
          filterState={filterState}
          setFilterState={setFilterState}
          isFromFilter={true}
          locationFolder={location}
        />
      )}
      {calendarActive.value && (
        <div className="editor-calendar-wrapper">
          <EditorCalendar
            filterState={filterState}
            setFilterState={setFilterState}
            setArchive={setShowingItems}
            archiveData={allData}
            calendarActive={calendarActive}
            setCalendarActive={setCalendarActive}
            daysArchive={daysArchive}
            isLandscape={false}
          />
        </div>
      )}
    </>
  );
};

export default FilterPortrait;
